import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_164348e8f9abe136e724217ae84b0663/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import '../styles/globals.scss';
import '../components/OldRender/components/ProductsService/index.scss';
import '../components/OldRender/editor-table.css';
import '@tencent/cms-design-component/lib/dist/style/main.css';
import '@tencent/tpm-product-intl/dist/TpmProductIntl.min.css';
import '@tencent/intl-design-ui/lib/scss/intl-ui.min.css';
import { DEFAULT_LANG } from 'common/constants';
import { isBrowser } from 'common/constants/config';
import { getI18nData, initI18nData } from 'common-translation/tools';
import App from 'next/app';
import Head from 'next/head';
import Script from 'next/script';
import CommonAppComp from 'portal-common/components/CommonApp';
import { PreviewTips } from 'portal-common/components/Tip';
import { getDomains } from 'portal-common/helpers/domainUtils';
import { getRealHostname } from 'portal-common/helpers/index';
import store from 'portal-common/store';
import { DomainContext } from '../components/OldRender/hooks/useDomainContext';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * 自定义App
 * @param {*} Component Component
 * @param {*} pageProps pageProps
 * @param {*} i18nData 多语言数据
 * @return {*}
 */ function CommonApp(param) {
    var Component = param.Component, pageProps = param.pageProps, i18nData = param.i18nData, domains = param.domains;
    !!i18nData && initI18nData(i18nData);
    var lang = (i18nData === null || i18nData === void 0 ? void 0 : i18nData.lang) || DEFAULT_LANG; // 这里获取到的语言是和url路由中的一样。要求和cookie里的language也一样，header和footer的动态语言包才能正确显示；
    isBrowser && store.setLang(lang);
    var appData = {
        lang: lang,
        title: Component.title,
        keywords: Component.keywords,
        description: Component.description,
        showLayout: false
    };
    return(/*#__PURE__*/ _jsxs(CommonAppComp, _objectSpread({}, appData, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                children: /*#__PURE__*/ _jsx("meta", {
                    name: "referrer",
                    content: "no-referrer-when-downgrade"
                })
            }),
            /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Script, {
                        children: "window.$qccomponent = {\n                header: {\n                  isNeedFix: false,\n                },\n              };\n            "
                    }),
                    /*#__PURE__*/ _jsx(Script, {
                        strategy: "afterInteractive",
                        id: "qccomponent-loader",
                        src: "/qccomponent/resources/loader.js?lang=".concat(lang)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(DomainContext.Provider, {
                value: domains,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: isBrowser && /*#__PURE__*/ _jsx(PreviewTips, {})
                    }),
                    /*#__PURE__*/ _jsx(Component, _objectSpread({}, pageProps, {
                        lang: lang
                    })),
                    /*#__PURE__*/ _jsx("script", {
                        src: 'https://t.captcha.qcloud.com/Captcha.js'
                    })
                ]
            })
        ]
    })));
}
/**
 * 把host存下来，后续使用
 * @param req
 */ var handleRequestHosts = function(req) {
    var realHostname = getRealHostname(req, {
        withoutPort: false
    });
    // const realHostnameWithoutPort = getRealHostname(req,  { withoutPort: true });
    var domains = getDomains(realHostname);
    // const domainsWithoutPort = getDomains(realHostnameWithoutPort);
    // const cookieDomain = `.${domainsWithoutPort.QCLOUD_ROOT_HOST}`; // 如果后续需要用到cookieDomain，这个也要存下来
    return domains;
};
CommonApp.getInitialProps = (function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(context) {
        var _ctx1, locale, req, domains, ref, i18nData, appProps;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx1 = context.ctx, locale = _ctx1.locale, req = _ctx1.req;
                    store.setLang(locale);
                    domains = handleRequestHosts(req);
                    _ctx.t0 = _slicedToArray;
                    _ctx.next = 6;
                    return Promise.all([
                        getI18nData({
                            ns: [
                                'common',
                                'cloud-market'
                            ],
                            lang: locale
                        }),
                        App.getInitialProps(context), 
                    ]);
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    i18nData = ref[0];
                    appProps = ref[1];
                    return _ctx.abrupt("return", _objectSpread({
                        i18nData: i18nData
                    }, appProps, {
                        domains: domains
                    }));
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
})();
export default CommonApp;
